<template>
  <v-app id="app">
    <v-app>
      <v-content>
        <v-container fluid>
          <router-view/>
        </v-container>
      </v-content>
    </v-app>
  </v-app>
</template>

<script>
export default {
  name: 'Reveal',
  data: () => ({
    menuVisible: false
  }),
  computed: {
    pdc_web_site() {
      let url = "pdc.wa.gov";
      if (location.host.search('localhost') >= 0) {
        url = 'http://demo-wapdc.pantheonsite.io';
      } else {
        if (location.host.search('pantheon') >= 0)
          url = 'http://demo-wapdc.pantheonsite.io';
      }
      return url;
    }
  }
}
</script>

<style lang="scss">
@import './main.scss';
</style>